import { request } from '@/utils'

// 获取当前用户权限操作列表
export function getPowerListAPI(){
  return request({
    url: '/power/list',
    method: 'GET'
  })
}
